var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Loading"},[_c('div',{staticClass:"LoadingIcon"},[_c('div',{staticClass:"Radius"}),_c('iconic',{attrs:{"name":_vm.app,"options":{ original: true }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }